import { useLanguageStore } from "@certa/common/store/language/useLanguageStore";
import { languages } from "../components/common/intlLanguages";

export const useGetPreferredLanguage = () => {
  return useLanguageStore(state => state.language);
};

export const renderLanguageName = (languageSymbol: string) => {
  const languageEndonym = (languages as { endonyms: Record<string, string> })
    .endonyms[languageSymbol];
  return languageEndonym
    ? `${languageSymbol}(${languageEndonym})`
    : languageSymbol;
};

export const renderLanguageNativeName = (languageSymbol: string) => {
  const languageEndonym = (languages as { endonyms: Record<string, string> })
    .endonyms[languageSymbol];
  const languageName = (languages as { names: Record<string, string> }).names[
    languageSymbol
  ];
  return languageEndonym ? languageEndonym : languageName;
};
